module.exports = __webpack_public_path__ + "media/mem_coupon.c6b93b01.mp4";